// Lamp mesh and geometry configuration
export const LAMP_CONFIG = {
    // Scale and dimension constraints
    MAX_DIMENSION: 250, // mm
    TARGET_FACE_SIZE: 3, // Target face size in mm
    // Base model constraints
    BASE_RADIUS: 45, // mm
    BASE_HEIGHT: 10, // mm
    FOOTPRINT_RADIUS: 30, // mm
    FOOTPRINT_HEIGHT: 150, // mm
    // Initial state
    INITIAL_STATE: {
        diameter: 100,
        height: 200,
        profilePoints: [
            { x: 1.0, y: 0.0 },
            { x: 1.0, y: 0.9 }
        ]
    },
    // Random generation settings
    RANDOM_GENERATION: {
        MAX_ATTEMPTS: 500,
        PROFILE: {
            MIN_RADIUS: 0.6,
            MAX_RADIUS: 0.85,
            MIN_POINTS: 3,
            MAX_POINTS: 6
        },
        MODIFIERS: {
            MIN_COUNT: 2,
            MAX_COUNT: 4,
            PARAMETER_LIMITS: {
                TWIST_ANGLE: 0.4,
                DISPLACEMENT: 0.6,
                RADIAL_WAVE: 0.5
            }
        },
        OVERHANG: {
            THRESHOLD_MULTIPLIER: 1.0
        }
    },
    // Geometry settings
    GEOMETRY: {
        MIN_SEGMENTS: 4,
        BOTTOM_CAP_EXTRUSION: {
            HEIGHT: 10, // mm
            HEIGHT_SEGMENTS: 1
        }
    },
    // Clash detection settings
    CLASH_DETECTION: {
        LIGHT_BASE: {
            RADIUS: 45, // mm
            HEIGHT: 10 // mm
        },
        LIGHT_GLOBE: {
            RADIUS: 15, // mm
            HEIGHT: 200 // mm
        }
    },
    // Printable area settings
    PRINTABLE_AREA: {
        WIDTH: 250, // mm
        DEPTH: 250, // mm
        HEIGHT: 250 // mm
    }
};
